"use strict";
/**
 * Created on 10 01 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");

var DomainObject_1 = require("./DomainObject");
/**
 * <p>A range in most generic way.</p>
 *
 * <p><b>It is presumed that 'T extends object'. We do not declare the generic type as 'T extends object' due to usage of primitive types,
 * such the 'number'. It would be event better to use 'T extends Comparable', but as far as I know., there is no such type in
 * typescript/js.</b></p>
 *
 * @author JMe
 */


var Range =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Range, _DomainObject_1$Domai);

  function Range(minimum, maximum) {
    var _this;

    _classCallCheck(this, Range);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this));
    _this.minimum = minimum;
    _this.maximum = maximum;
    return _this;
  }
  /**
   * @returns true if both the minimum value and the maximum value is not included within the range.
   */


  _createClass(Range, [{
    key: "isUnbounded",
    value: function isUnbounded() {
      return !this.isMinIncluded() && !this.isMaxIncluded();
    }
    /**
     * @returns true if the minimum value is included within the range. If the range is unbounded at this end, this method will return true.
     */

  }, {
    key: "isMinIncluded",
    value: function isMinIncluded() {
      return this.minimum !== null;
    }
    /**
     * @returns true if the maximum value is included within the range. If the range is unbounded at this end, this method will return true.
     */

  }, {
    key: "isMaxIncluded",
    value: function isMaxIncluded() {
      return this.maximum !== null;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other instanceof Range) {
        return this.isValuesEqual(this.minimum, other.minimum) && this.isValuesEqual(this.maximum, other.maximum);
      } else {
        return false;
      }
    }
  }, {
    key: "isValuesEqual",
    value: function isValuesEqual(value1, value2) {
      if (value1 !== null && value2 !== null) {
        if (value1.equals) {
          if (!value1.equals(value2)) {
            return false;
          }

          return true;
        }

        return value1 === value2;
      }

      return value1 === null && value2 === null;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      var minimumAsStr = "".concat(this.minimum !== null ? this.minimum.toString() : 'null');
      var maximumAsStr = "".concat(this.maximum !== null ? this.maximum.toString() : 'null');
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(minimumAsStr, "_").concat(maximumAsStr));
    }
  }]);

  return Range;
}(DomainObject_1.DomainObject);

exports.Range = Range;